import api from ".";

interface ILogin {
  cpf: string;
  password: string;
}

export const login = async (data: ILogin) => {
  try {
    const response = await api.post("/api/v1/login", data);
    return response;
  } catch (error: any) {
    console.error(
      "Erro ao tentar fazer login:",
      error.response?.data || error.message
    );
    throw error;
  }
};
